import React, { Component } from "react";
import { connect } from "react-redux";

import moment from "moment";

import { logar_signatario } from "../../actions";

import "./auth.css";

import {
  formatDateInput,
  campoInvalido,
  isAuthenticatedDocSig,
} from "../../utils";

class Auth extends Component {
  constructor() {
    super();

    this.state = {
      cpfCnpj: "",
      dataNasc: "",
      nome: "",
      token: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.logar = this.logar.bind(this);
  }

  componentWillMount() {
    localStorage.clear();
  }

  handleInputChange(event) {
    let name = event.target.name;
    let val = event.target.value;
    this.setState({ [name]: val });
  }

  logar(event) {
    event.preventDefault();

    for (let i in this.state) {
      campoInvalido(i);
      if (
        i != "hashed_id" &&
        (this.state[i] == undefined || this.state[i].trim() == "")
      )
        return alert("Preencha todos os campos.");
      if (i == "dataNasc" && !moment(this.state[i], "DD/MM/YYYY").isValid())
        return alert("Data inválida");
    }

    this.props.logar_signatario(this.state, () =>
      this.props.history.push("/documento")
    );
  }

  render() {
    const { login_sig, error_sig_auth } = this.props.auth;

    return (
      <div
        className="principal"
        style={{ width: "100%", marginTop: 0, display: "flex" }}
      >
        <form className="form-signin" onSubmit={this.logar}>
          <img
            className="mb-4"
            src="/assets/imagem/logo-fondo-claro.png"
            alt="Logo Finsol"
            style={{ height: "100%", width: "100%", objectFit: "contain" }}
          />
          <div className="form-group">
            <label className="sr-only">Código</label>
            <input
              value={this.state.token}
              name="token"
              type="text"
              id="inputToken"
              className="form-control"
              placeholder="Código"
              required
              onChange={this.handleInputChange}
            />
          </div>

          <div className="form-group">
            <label className="sr-only">CPF/CNPJ</label>
            <input
              value={this.state.cpfCnpj}
              maxLength="14"
              name="cpfCnpj"
              type="text"
              id="inputEmail"
              className="form-control"
              placeholder="CPF/CPNJ"
              required
              onChange={this.handleInputChange}
            />
          </div>

          <div className="form-group">
            <label className="sr-only">Nome</label>
            <input
              value={this.state.nome}
              name="nome"
              type="text"
              id="inputPassword"
              className="form-control"
              placeholder="Nome completo"
              required
              onChange={this.handleInputChange}
            />
          </div>

          <div className="form-group">
            <label className="sr-only">Data Nascimento</label>
            <input
              placeholder="dd/mm/aaaa"
              name="dataNasc"
              type="text"
              id="inputPassword"
              className="form-control"
              required
              value={formatDateInput(this.state.dataNasc)}
              onChange={this.handleInputChange}
              onBlur={() => campoInvalido("dataNasc")}
            />
          </div>

          <button
            className="btn btn-lg btn-primary btn-block"
            type="submit"
            role="button"
            disabled={login_sig}
          >
            {login_sig ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : null}
            {login_sig ? "   Aguarde..." : "Entrar"}
          </button>

          {error_sig_auth != "" ? (
            <div
              className="alert alert-danger"
              role="alert"
              style={{ marginTop: "5%" }}
            >
              {error_sig_auth}
            </div>
          ) : null}
          <small className="mt-5 mb-3 text-muted">&copy; RBMWEB 2020</small>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    auth,
  };
};

export default connect(mapStateToProps, {
  logar_signatario,
})(Auth);
